export default "__VITE_ASSET__CpJRxrQ3__"